// extracted by mini-css-extract-plugin
export default {"svg":"TransportDescription_svg__LtLeO"};